export default {
      id: "bar_chart-usage",
      viewBox: "0 0 40 37",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#bar_chart",
      toString: function () {
        return this.url;
      }
    }